<admin-breadcrumbs></admin-breadcrumbs>

<header class="page-header">
  <div class="page-header__top">
    <div>
      <h1>Fax to Email</h1>
      <p class="subtitle">
        Manage fax-to-email mappings for your region's facilities. Each facility can
        have one email address assigned for receiving faxes.
      </p>
    </div>
    <div class="export-wrap">
      <button type="button" class="btn btn-secondary" (click)="showExportPrompt = !showExportPrompt">
        Export CSV
      </button>
      <div *ngIf="showExportPrompt" class="export-dropdown">
        <button type="button" class="export-option" (click)="exportCsv(true)">
          Only with fax email
        </button>
        <button type="button" class="export-option" (click)="exportCsv(false)">
          All facilities
        </button>
      </div>
    </div>
  </div>
</header>

<div *ngIf="loading" class="loading-banner">Loading…</div>

<div *ngIf="!loading" class="table-wrap">
  <table class="fax-table">
    <thead>
      <tr>
        <th class="id-col">Facility ID</th>
        <th class="name-col">Facility Name</th>
        <th class="referral-col">Referral Active</th>
        <th class="sitename-col">Site Name</th>
        <th class="email-col">Fax Email</th>
        <th class="actions-col">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows; trackBy: trackByFacilityId"
          [class.has-mapping]="!!row.mapping"
          [class.no-mapping]="!row.mapping">

        <td class="id-col">{{ row.facilityId }}</td>

        <td class="name-col">{{ row.name }}</td>

        <td class="referral-col">
          <span class="badge" [class.badge-active]="row.referralActive" [class.badge-inactive]="!row.referralActive">
            {{ row.referralActive ? 'Active' : 'Inactive' }}
          </span>
        </td>

        <td class="sitename-col">
          <ng-container *ngIf="editingFacilityId === row.facilityId; else siteNameView">
            <input
              type="text"
              class="text-input"
              [(ngModel)]="editingSiteName"
              (keyup.enter)="saveEdit(row)"
              (keyup.escape)="cancelEdit()"
              placeholder="Site name"
            />
          </ng-container>
          <ng-template #siteNameView>
            <span *ngIf="row.mapping?.siteName">{{ row.mapping.siteName }}</span>
            <span *ngIf="!row.mapping?.siteName" class="no-email">—</span>
          </ng-template>
        </td>

        <td class="email-col">
          <ng-container *ngIf="editingFacilityId === row.facilityId; else emailView">
            <input
              type="email"
              class="text-input"
              [(ngModel)]="editingEmail"
              (keyup.enter)="saveEdit(row)"
              (keyup.escape)="cancelEdit()"
              placeholder="email@example.com"
              autofocus
            />
          </ng-container>
          <ng-template #emailView>
            <span *ngIf="row.mapping" class="email-text">{{ row.mapping.email }}</span>
            <span *ngIf="!row.mapping" class="no-email">—</span>
          </ng-template>
        </td>

        <td class="actions-col">
          <ng-container *ngIf="editingFacilityId === row.facilityId; else actionButtons">
            <button type="button" class="btn btn-primary" (click)="saveEdit(row)">Save</button>
            <button type="button" class="btn btn-ghost" (click)="cancelEdit()">Cancel</button>
          </ng-container>
          <ng-template #actionButtons>
            <button
              type="button"
              class="btn btn-ghost"
              (click)="startEdit(row)"
              [title]="row.mapping ? 'Edit email' : 'Add email'"
            >{{ row.mapping ? '✏️ Edit' : '+ Add' }}</button>
            <button
              *ngIf="row.mapping"
              type="button"
              class="btn btn-ghost danger"
              title="Remove mapping"
              (click)="deleteMapping(row)"
            >🗑️ Remove</button>
          </ng-template>
        </td>
      </tr>
      <tr *ngIf="rows.length === 0">
        <td colspan="6" class="empty-row">No facilities found for your region.</td>
      </tr>
    </tbody>
  </table>
</div>
